import moment from 'moment';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import withOptions from 'utils/functions/withOptions.util';

const openAsMoment = () => moment('09:00 AM', 'HH:mm a');
const closeAsMoment = () => moment('06:00 PM', 'HH:mm a');

const generateDefaultSalonData = withOptions(({ address1, address2, address_line_1: al1, address_line_2: al2, city, state, email, phone, phoneNumber }) => ({
  // hardcoded values
  id: undefined,
  name: '',
  numberOfEmployees: '1',
  pricing_type: 'role',
  postcode: '',

  // values from options
  email: fromAnyToTrimmed(email),
  phone: fromAnyToTrimmed(phone) || fromAnyToTrimmed(phoneNumber),
  city: fromAnyToTrimmed(city),
  state: fromAnyToTrimmed(state) || undefined,
  address_line_1: fromAnyToTrimmed(address1) || fromAnyToTrimmed(al1),
  address_line_2: fromAnyToTrimmed(address2) || fromAnyToTrimmed(al2),
  vat: '',
  // default working hours
  mon_open: false,
  mon_open_time: openAsMoment(),
  mon_close_time: closeAsMoment(),
  tue_open: true,
  tue_open_time: openAsMoment(),
  tue_close_time: closeAsMoment(),
  wed_open: true,
  wed_open_time: openAsMoment(),
  wed_close_time: closeAsMoment(),
  thu_open: true,
  thu_open_time: openAsMoment(),
  thu_close_time: closeAsMoment(),
  fri_open: true,
  fri_open_time: openAsMoment(),
  fri_close_time: closeAsMoment(),
  sat_open: true,
  sat_open_time: openAsMoment(),
  sat_close_time: closeAsMoment(),
  sun_open: false,
  sun_open_time: openAsMoment(),
  sun_close_time: closeAsMoment(),
}));

export default generateDefaultSalonData;
